/**
 * Replace a prefix in a string
 *
 * @param {string} str
 * @param {string} prefix
 *
 * @returns {string}
 */
export default function stripPrefix(id, prefix) {
  return id?.startsWith(prefix) ? id.replace(prefix, "") : id;
}
